export const ChevronRight = ({ fill_color }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_12740_27066)">
        <path
          className={fill_color ? undefined : "fill-secondary"}
          fill={fill_color ? fill_color : undefined}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.93829 10.3115C3.68724 10.0604 3.68724 9.65338 3.93829 9.40233L7.34086 5.99976L3.93829 2.59718C3.68724 2.34613 3.68724 1.9391 3.93829 1.68804C4.18934 1.43699 4.59637 1.43699 4.84743 1.68804L8.70457 5.54519C8.95562 5.79624 8.95562 6.20327 8.70457 6.45432L4.84743 10.3115C4.59637 10.5625 4.18934 10.5625 3.93829 10.3115Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_12740_27066">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="matrix(1 0 0 -1 0 11.9998)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-primary"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0984 7.1195C10.0984 8.88063 8.64097 10.3489 6.79272 10.3489C4.94447 10.3489 3.48706 8.88063 3.48706 7.1195C3.48706 5.35838 4.94447 3.89014 6.79272 3.89014C8.64097 3.89014 10.0984 5.35838 10.0984 7.1195ZM9.60734 10.9373C8.81703 11.5026 7.84444 11.8359 6.79272 11.8359C4.14577 11.8359 2 9.72431 2 7.1195C2 4.51469 4.14577 2.40308 6.79272 2.40308C9.43966 2.40308 11.5854 4.51469 11.5854 7.1195C11.5854 8.1561 11.2456 9.1146 10.6696 9.89299L14.2279 13.1078C14.5326 13.3831 14.5564 13.8533 14.2811 14.158C14.0058 14.4627 13.5357 14.4865 13.231 14.2112L9.60734 10.9373Z"
      />
    </svg>
  );
};

export const ArrowRightFilledCircle = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.403076"
        width="16"
        height="16"
        rx="8"
        className="fill-primary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8669 8.92601C13.0444 8.75555 13.0444 8.47918 12.8669 8.30872L9.97416 5.53092C9.79665 5.36046 9.50884 5.36046 9.33133 5.53092C9.15382 5.70138 9.15382 5.97775 9.33133 6.14821L11.4481 8.18087L3.45455 8.18087C3.20351 8.18087 3 8.3763 3 8.61736C3 8.85843 3.20351 9.05385 3.45455 9.05385L11.4481 9.05385L9.33133 11.0865C9.15382 11.257 9.15382 11.5333 9.33133 11.7038C9.50884 11.8743 9.79665 11.8743 9.97416 11.7038L12.8669 8.92601Z"
        fill="white"
      />
    </svg>
  );
};

export const CrossCircleFilled = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 8.93325L9.93398 10.8666C10.0562 10.9888 10.2118 11.0499 10.4007 11.0499C10.5895 11.0499 10.7451 10.9888 10.8673 10.8666C10.9895 10.7444 11.0507 10.5888 11.0507 10.3999C11.0507 10.211 10.9895 10.0555 10.8673 9.93325L8.93398 7.99992L10.8673 6.06659C10.9895 5.94436 11.0507 5.78881 11.0507 5.59992C11.0507 5.41103 10.9895 5.25547 10.8673 5.13325C10.7451 5.01103 10.5895 4.94992 10.4007 4.94992C10.2118 4.94992 10.0562 5.01103 9.93398 5.13325L8.00065 7.06659L6.06732 5.13325C5.9451 5.01103 5.78954 4.94992 5.60065 4.94992C5.41176 4.94992 5.25621 5.01103 5.13399 5.13325C5.01176 5.25547 4.95065 5.41103 4.95065 5.59992C4.95065 5.78881 5.01176 5.94436 5.13399 6.06659L7.06732 7.99992L5.13399 9.93325C5.01176 10.0555 4.95065 10.211 4.95065 10.3999C4.95065 10.5888 5.01176 10.7444 5.13399 10.8666C5.25621 10.9888 5.41176 11.0499 5.60065 11.0499C5.78954 11.0499 5.9451 10.9888 6.06732 10.8666L8.00065 8.93325ZM8.00065 14.6666C7.07843 14.6666 6.21176 14.4915 5.40065 14.1413C4.58954 13.791 3.88399 13.3161 3.28399 12.7166C2.68399 12.117 2.2091 11.4115 1.85932 10.5999C1.50954 9.78836 1.33443 8.9217 1.33399 7.99992C1.33354 7.07814 1.50865 6.21147 1.85932 5.39992C2.20999 4.58836 2.68487 3.88281 3.28399 3.28325C3.8831 2.6837 4.58865 2.20881 5.40065 1.85859C6.21265 1.50836 7.07932 1.33325 8.00065 1.33325C8.92199 1.33325 9.78865 1.50836 10.6007 1.85859C11.4127 2.20881 12.1182 2.6837 12.7173 3.28325C13.3164 3.88281 13.7915 4.58836 14.1427 5.39992C14.4938 6.21147 14.6687 7.07814 14.6673 7.99992C14.666 8.9217 14.4909 9.78836 14.142 10.5999C13.7931 11.4115 13.3182 12.117 12.7173 12.7166C12.1164 13.3161 11.4109 13.7913 10.6007 14.1419C9.79043 14.4926 8.92376 14.6675 8.00065 14.6666Z"
        // fill="#7953D2"
        className="fill-primary"
      />
    </svg>
  );
};

export const AddCircle = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33337 7.99967C1.33337 4.31767 4.31804 1.33301 8.00004 1.33301C11.682 1.33301 14.6667 4.31767 14.6667 7.99967C14.6667 11.6817 11.682 14.6663 8.00004 14.6663C4.31804 14.6663 1.33337 11.6817 1.33337 7.99967ZM8.00004 2.66634C6.58555 2.66634 5.229 3.22824 4.2288 4.22844C3.22861 5.22863 2.66671 6.58519 2.66671 7.99967C2.66671 9.41416 3.22861 10.7707 4.2288 11.7709C5.229 12.7711 6.58555 13.333 8.00004 13.333C9.41453 13.333 10.7711 12.7711 11.7713 11.7709C12.7715 10.7707 13.3334 9.41416 13.3334 7.99967C13.3334 6.58519 12.7715 5.22863 11.7713 4.22844C10.7711 3.22824 9.41453 2.66634 8.00004 2.66634Z"
        className="fill-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66667 4.66667C8.66667 4.48986 8.59643 4.32029 8.4714 4.19526C8.34638 4.07024 8.17681 4 8 4C7.82319 4 7.65362 4.07024 7.5286 4.19526C7.40357 4.32029 7.33333 4.48986 7.33333 4.66667V7.33333H4.66667C4.48986 7.33333 4.32029 7.40357 4.19526 7.5286C4.07024 7.65362 4 7.82319 4 8C4 8.17681 4.07024 8.34638 4.19526 8.4714C4.32029 8.59643 4.48986 8.66667 4.66667 8.66667H7.33333V11.3333C7.33333 11.5101 7.40357 11.6797 7.5286 11.8047C7.65362 11.9298 7.82319 12 8 12C8.17681 12 8.34638 11.9298 8.4714 11.8047C8.59643 11.6797 8.66667 11.5101 8.66667 11.3333V8.66667H11.3333C11.5101 8.66667 11.6797 8.59643 11.8047 8.4714C11.9298 8.34638 12 8.17681 12 8C12 7.82319 11.9298 7.65362 11.8047 7.5286C11.6797 7.40357 11.5101 7.33333 11.3333 7.33333H8.66667V4.66667Z"
        className="fill-secondary"
      />
    </svg>
  );
};

export const Wallet = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.334 10H15.0007V13.3333H13.334V10Z"
        className="fill-primary"
      />
      <path
        d="M16.666 5.83333V4.16667C16.666 3.2475 15.9185 2.5 14.9993 2.5H4.16602C2.78768 2.5 1.66602 3.62167 1.66602 5V15C1.66602 16.8342 3.16102 17.5 4.16602 17.5H16.666C17.5852 17.5 18.3327 16.7525 18.3327 15.8333V7.5C18.3327 6.58083 17.5852 5.83333 16.666 5.83333ZM4.16602 4.16667H14.9993V5.83333H4.16602C3.95145 5.82374 3.74885 5.73174 3.60041 5.57651C3.45197 5.42129 3.36913 5.21478 3.36913 5C3.36913 4.78522 3.45197 4.57871 3.60041 4.42349C3.74885 4.26826 3.95145 4.17626 4.16602 4.16667ZM16.666 15.8333H4.17602C3.79102 15.8233 3.33268 15.6708 3.33268 15V7.34583C3.59435 7.44 3.87185 7.5 4.16602 7.5H16.666V15.8333Z"
        className="fill-primary"
      />
    </svg>
  );
};

export const ArrowRightCircle = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="15" height="15" rx="7.5" fill="white" />
      <rect
        x="0.5"
        y="1"
        width="15"
        height="15"
        rx="7.5"
        className="stroke-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.64645 11.8536C6.45118 11.6583 6.45118 11.3417 6.64645 11.1464L9.29289 8.5L6.64645 5.85355C6.45118 5.65829 6.45118 5.34171 6.64645 5.14645C6.84171 4.95118 7.15829 4.95118 7.35355 5.14645L10.3536 8.14645C10.5488 8.34171 10.5488 8.65829 10.3536 8.85355L7.35355 11.8536C7.15829 12.0488 6.84171 12.0488 6.64645 11.8536Z"
        className="fill-secondary"
      />
    </svg>
  );
};

export const ClockIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.844 10.7064C3.40791 11.8468 4.32271 12.7764 5.454 13.3584C6.577 13.9353 7.85759 14.1301 9.10133 13.9131C10.3489 13.6935 11.4918 13.0761 12.3593 12.1531C13.2346 11.2211 13.792 10.0357 13.9513 8.76707C14.1128 7.49557 13.8693 6.20551 13.2553 5.08041C12.647 3.96387 11.696 3.07229 10.5427 2.53707C9.39713 2.00652 8.10976 1.8642 6.876 2.13174C5.64267 2.39907 4.632 3.00707 3.796 3.96841C3.69533 4.07507 3.306 4.50574 2.98267 5.15574M5 5.33307L2.594 5.81307L2 3.33307M8 5.99974V8.66641L10 9.99974"
        // stroke="#00B9F1"
        className="stroke-secondary"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Calendar = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.66683H11.3333V2.00016C11.3333 1.82335 11.2631 1.65378 11.1381 1.52876C11.013 1.40373 10.8435 1.3335 10.6667 1.3335C10.4899 1.3335 10.3203 1.40373 10.1953 1.52876C10.0702 1.65378 10 1.82335 10 2.00016V2.66683H6V2.00016C6 1.82335 5.92976 1.65378 5.80474 1.52876C5.67971 1.40373 5.51014 1.3335 5.33333 1.3335C5.15652 1.3335 4.98695 1.40373 4.86193 1.52876C4.7369 1.65378 4.66667 1.82335 4.66667 2.00016V2.66683H4C3.46957 2.66683 2.96086 2.87754 2.58579 3.25262C2.21071 3.62769 2 4.1364 2 4.66683V12.6668C2 13.1973 2.21071 13.706 2.58579 14.081C2.96086 14.4561 3.46957 14.6668 4 14.6668H12C12.5304 14.6668 13.0391 14.4561 13.4142 14.081C13.7893 13.706 14 13.1973 14 12.6668V4.66683C14 4.1364 13.7893 3.62769 13.4142 3.25262C13.0391 2.87754 12.5304 2.66683 12 2.66683ZM4 4.00016H4.66667V4.66683C4.66667 4.84364 4.7369 5.01321 4.86193 5.13823C4.98695 5.26326 5.15652 5.3335 5.33333 5.3335C5.51014 5.3335 5.67971 5.26326 5.80474 5.13823C5.92976 5.01321 6 4.84364 6 4.66683V4.00016H10V4.66683C10 4.84364 10.0702 5.01321 10.1953 5.13823C10.3203 5.26326 10.4899 5.3335 10.6667 5.3335C10.8435 5.3335 11.013 5.26326 11.1381 5.13823C11.2631 5.01321 11.3333 4.84364 11.3333 4.66683V4.00016H12C12.1768 4.00016 12.3464 4.0704 12.4714 4.19542C12.5964 4.32045 12.6667 4.49002 12.6667 4.66683V7.3335H3.33333V4.66683C3.33333 4.49002 3.40357 4.32045 3.5286 4.19542C3.65362 4.0704 3.82319 4.00016 4 4.00016ZM12 13.3335H4C3.82319 13.3335 3.65362 13.2633 3.5286 13.1382C3.40357 13.0132 3.33333 12.8436 3.33333 12.6668V8.66683H12.6667V12.6668C12.6667 12.8436 12.5964 13.0132 12.4714 13.1382C12.3464 13.2633 12.1768 13.3335 12 13.3335Z"
        className="fill-secondary"
      />
      <path
        d="M5.3339 11.3333C5.70209 11.3333 6.00057 11.0349 6.00057 10.6667C6.00057 10.2985 5.70209 10 5.3339 10C4.96571 10 4.66724 10.2985 4.66724 10.6667C4.66724 11.0349 4.96571 11.3333 5.3339 11.3333Z"
        className="fill-secondary"
      />
      <path
        d="M10.6661 10H7.99943C7.82262 10 7.65305 10.0702 7.52803 10.1953C7.403 10.3203 7.33276 10.4899 7.33276 10.6667C7.33276 10.8435 7.403 11.013 7.52803 11.1381C7.65305 11.2631 7.82262 11.3333 7.99943 11.3333H10.6661C10.8429 11.3333 11.0125 11.2631 11.1375 11.1381C11.2625 11.013 11.3328 10.8435 11.3328 10.6667C11.3328 10.4899 11.2625 10.3203 11.1375 10.1953C11.0125 10.0702 10.8429 10 10.6661 10Z"
        className="fill-secondary"
      />
    </svg>
  );
};

export const CallCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="11.5"
        // stroke="#C7E9F3"
        className="stroke-accents"
      />
      <path
        d="M16.82 14.1735L15.1267 13.9802C14.9276 13.9568 14.7258 13.9788 14.5364 14.0446C14.347 14.1105 14.175 14.2183 14.0334 14.3602L12.8067 15.5868C10.9143 14.6241 9.37607 13.0859 8.41336 11.1935L9.64669 9.96017C9.93336 9.6735 10.0734 9.2735 10.0267 8.86684L9.83336 7.18684C9.7957 6.86156 9.63967 6.56152 9.395 6.3439C9.15033 6.12628 8.83414 6.0063 8.50669 6.00684H7.35336C6.60003 6.00684 5.97336 6.6335 6.02003 7.38684C6.37336 13.0802 10.9267 17.6268 16.6134 17.9802C17.3667 18.0268 17.9934 17.4002 17.9934 16.6468V15.4935C18 14.8202 17.4934 14.2535 16.82 14.1735Z"
        // fill="#00B9F1"
        className="fill-secondary"
      />
    </svg>
  );
};

export const ChevronDownBlue = () => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.09309 3.78191C8.88388 3.5727 8.54469 3.5727 8.33548 3.78191L5.5 6.61739L2.66452 3.78191C2.45531 3.5727 2.11612 3.5727 1.90691 3.78191C1.6977 3.99112 1.6977 4.33031 1.90691 4.53952L5.12119 7.75381C5.3304 7.96302 5.6696 7.96302 5.87881 7.75381L9.09309 4.53952C9.3023 4.33031 9.3023 3.99112 9.09309 3.78191Z"
        className="fill-secondary"
      />
    </svg>
  );
};

export const Retry = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <g clipPath="url(#clip0_14541_2789)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.575 0.0181109C5.43794 -0.0555368 6.30522 0.0962445 7.09187 0.458587C7.87852 0.820929 8.55757 1.38141 9.0625 2.08511V1.0938C9.0625 0.969475 9.11189 0.850239 9.19979 0.762326C9.2877 0.674413 9.40693 0.625024 9.53125 0.625024C9.65557 0.625024 9.7748 0.674413 9.86271 0.762326C9.95061 0.850239 10 0.969475 10 1.0938V3.75022H7.34375C7.21943 3.75022 7.1002 3.70083 7.01229 3.61292C6.92439 3.525 6.875 3.40577 6.875 3.28144C6.875 3.15711 6.92439 3.03787 7.01229 2.94996C7.1002 2.86205 7.21943 2.81266 7.34375 2.81266H8.42313C7.9957 2.14381 7.38171 1.61483 6.65701 1.29106C5.93232 0.967289 5.12865 0.862918 4.3453 0.990836C3.56195 1.11875 2.83323 1.47336 2.24915 2.01085C1.66508 2.54833 1.25124 3.24515 1.05875 4.01523C1.04455 4.07573 1.01847 4.13279 0.982021 4.18311C0.945572 4.23344 0.899483 4.27601 0.846434 4.30836C0.793385 4.3407 0.734435 4.36218 0.673011 4.37154C0.611587 4.3809 0.548916 4.37796 0.488641 4.36288C0.428365 4.3478 0.37169 4.32088 0.321908 4.2837C0.272127 4.24652 0.230234 4.19981 0.198666 4.14629C0.167097 4.09277 0.146482 4.03351 0.13802 3.97196C0.129558 3.9104 0.133418 3.84777 0.149375 3.78772C0.402215 2.77667 0.964626 1.8699 1.758 1.19415C2.55136 0.518401 3.53604 0.107448 4.57437 0.0187359L4.575 0.0181109ZM2.45 9.30119C3.11999 9.69832 3.87349 9.93344 4.65043 9.98781C5.42736 10.0422 6.20626 9.91427 6.92502 9.6143C7.64378 9.31433 8.28253 8.85059 8.79036 8.26005C9.29818 7.6695 9.66104 6.96848 9.85 6.21287C9.87814 6.09299 9.85798 5.96684 9.79387 5.8617C9.72977 5.75656 9.62687 5.68087 9.50741 5.65098C9.38796 5.6211 9.26154 5.63942 9.15549 5.70199C9.04943 5.76455 8.97225 5.86634 8.94063 5.98536C8.74803 6.75527 8.33418 7.45192 7.75015 7.98927C7.16613 8.52662 6.43752 8.88113 5.6543 9.00904C4.87108 9.13695 4.06756 9.03265 3.34294 8.70901C2.61833 8.38538 2.00437 7.85658 1.57687 7.18793H2.65625C2.78057 7.18793 2.8998 7.13854 2.98771 7.05063C3.07561 6.96272 3.125 6.84348 3.125 6.71915C3.125 6.59482 3.07561 6.47559 2.98771 6.38767C2.8998 6.29976 2.78057 6.25037 2.65625 6.25037H0V8.90679C0 9.03112 0.049386 9.15035 0.137294 9.23826C0.225201 9.32618 0.34443 9.37557 0.46875 9.37557C0.59307 9.37557 0.712299 9.32618 0.800206 9.23826C0.888114 9.15035 0.9375 9.03112 0.9375 8.90679V7.91548C1.34049 8.47695 1.85549 8.94878 2.45 9.30119Z"
          // fill="#7953D2"
          className="fill-secondary"
        />
      </g>
      <defs>
        <clipPath id="clip0_14541_2789">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7688 6.73509H9.26491V1.23119C9.26491 -0.410396 6.73509 -0.410396 6.73509 1.23119V6.73509H1.23119C-0.410396 6.73509 -0.410396 9.26491 1.23119 9.26491H6.73509V14.7688C6.73509 16.4104 9.26491 16.4104 9.26491 14.7688V9.26491H14.7688C16.3911 9.28431 16.3911 6.73509 14.7688 6.73509Z"
        // fill="#002E6E"
        className="fill-primary"
      />
    </svg>
  );
};

export const GpsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M24 22C25.0609 22 26.0783 21.5786 26.8284 20.8284C27.5786 20.0783 28 19.0609 28 18C28 16.9391 27.5786 15.9217 26.8284 15.1716C26.0783 14.4214 25.0609 14 24 14C22.9391 14 21.9217 14.4214 21.1716 15.1716C20.4214 15.9217 20 16.9391 20 18C20 19.0609 20.4214 20.0783 21.1716 20.8284C21.9217 21.5786 22.9391 22 24 22Z"
        // fill="#7953D2"
        className="fill-secondary"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36 18C36.0004 20.8362 34.9963 23.5808 33.1657 25.7471C31.3352 27.9134 28.7965 29.3613 26 29.834V40C26 40.5304 25.7893 41.0391 25.4142 41.4142C25.0391 41.7893 24.5304 42 24 42C23.4696 42 22.9609 41.7893 22.5858 41.4142C22.2107 41.0391 22 40.5304 22 40V29.834C19.0399 29.3245 16.3783 27.7238 14.5407 25.3478C12.7031 22.9719 11.823 19.9933 12.0742 17.0002C12.3253 14.007 13.6895 11.2168 15.8974 9.18031C18.1052 7.14382 20.9963 6.00904 24 6C27.1826 6 30.2348 7.26428 32.4853 9.51472C34.7357 11.7652 36 14.8174 36 18ZM24 26C26.1217 26 28.1566 25.1571 29.6569 23.6569C31.1571 22.1566 32 20.1217 32 18C32 15.8783 31.1571 13.8434 29.6569 12.3431C28.1566 10.8429 26.1217 10 24 10C21.8783 10 19.8434 10.8429 18.3431 12.3431C16.8429 13.8434 16 15.8783 16 18C16 20.1217 16.8429 22.1566 18.3431 23.6569C19.8434 25.1571 21.8783 26 24 26Z"
        fill="black"
      />
    </svg>
  );
};
